export default __webpack_public_path__ + "static/logo-3dd3ecdef1305cb7961e6ce503b70b00.svg";